export { CarReviewsV2Feature } from "./lib/car-reviews-v2";
export { getStaticProps } from "./lib/get-static-props";
export { getStaticPaths } from "./lib/get-static-paths";
